export const blogTypes = {
    GET_POSTS_LIST: "GET_POSTS_LIST",
    GET_FOOTER_POSTS_LIST: "GET_FOOTER_POSTS_LIST",
    GET_POST_NOT_FOUND: "GET_POST_NOT_FOUND",
    GET_POST_DETAILS: "GET_POST_DETAILS",
    GET_POST_DETAILS_NOT_FOUND: "GET_POST_DETAILS_NOT_FOUND",
    ADDING_COMMENT_STATUS: "ADDING_COMMENT_STATUS",
    SEND_BLOG_COMMENT: "SEND_BLOG_COMMENT",
    CLEAR_BLOG_DATA: "CLEAR_BLOG_DATA",
};